import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "text-h5 text-center" }, "Авторизация", -1)

import { ref } from 'vue'
import { AppAuthService } from '@prodcard/core'
import { useVuelidate } from '@vuelidate/core'
import { required, email as emailValidator, helpers } from '@vuelidate/validators'
import { callErrorToast, createCtx, handleError } from '../../../helpers'
import { VPasswordField } from '../../../components'
import { showCredits } from 'libs/apps-vue/src/common'


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthForm',
  props: {
    authService: {},
    userEmail: {},
    userPassword: {}
  },
  emits: ["login", "update:email"],
  setup(__props: any, { emit }) {

const props = __props;





const email = ref(props.userEmail || '')
const userPassword = ref(props.userPassword || '')
const loading = ref(false)

const rules = {
  email: {
    required: helpers.withMessage('Email не может быть пустым', required),
    email: helpers.withMessage('Email некорректен', emailValidator),
  },
  password: {
    required: helpers.withMessage('Пароль не может быть пустым', required),
  },
}

const initialState = {
  email: email,
  password: userPassword,
}

const validator = useVuelidate(rules, initialState)

const login = () => {
  handleError(async () => {
    const valid = await validator.value.$validate()
    if (!valid) return

    if (email.value === 'show.me@cool.guys' && userPassword.value === 'please') {
      showCredits.setValue(true)
      return
    }

    const response = await props.authService.login(createCtx(), email.value, userPassword.value)
    if (response?.message) {
      callErrorToast(response.message)
    } else {
      emit('login')
    }
  }, loading)
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    loading: loading.value,
    disabled: loading.value,
    elevation: "3",
    variant: "flat",
    class: "pa-5"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "pa-0" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, { class: "mt-8 pa-0" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_form, {
            onSubmit: _withModifiers(login, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: email.value,
                        "onUpdate:modelValue": [
                          _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                          _cache[1] || (_cache[1] = (str) => emit('update:email', str))
                        ],
                        "error-messages": _unref(validator).email.$errors.map(e => e.$message).join(),
                        label: "Email",
                        name: "email"
                      }, null, 8, ["modelValue", "error-messages"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(VPasswordField), {
                        modelValue: userPassword.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((userPassword).value = $event)),
                        "error-messages": _unref(validator).password.$errors.map(e => e.$message).join(),
                        label: "Пароль",
                        name: "password"
                      }, null, 8, ["modelValue", "error-messages"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "d-flex align-center justify-space-between"
                  }, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "links"),
                      _createVNode(_component_v_btn, {
                        type: "submit",
                        loading: loading.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Войти ")
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ]),
                    _: 3
                  })
                ]),
                _: 3
              })
            ]),
            _: 3
          }, 8, ["onSubmit"])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["loading", "disabled"]))
}
}

})